/* 🤖 this file was generated by svg-to-ts */
export const fthrXOctagon: {
    name: 'fthr-x-octagon';
    data: string;
} = {
    name: 'fthr-x-octagon',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-x-octagon" viewBox="0 0 24 24"><path d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86zM15 9l-6 6M9 9l6 6"/></svg>`,
};
